"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSaleNFTForm = void 0;
const default_contract_action_1 = require("@components/default-contract-action");
const token_select_1 = require("@components/token-select");
const market_hooks_1 = require("@hooks/contracts/market.hooks");
const form_hooks_1 = require("@hooks/form.hooks");
const translation_hooks_1 = require("@hooks/translation.hooks");
const currency_input_1 = require("@shared-modules/components/currency-input");
const react_1 = __importDefault(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const CreateSaleNFTForm = (props) => {
    var _a;
    const { token, onClose } = props;
    const translator = (0, translation_hooks_1.useComponentTranslation)("createSaleNFTForm");
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    const addToMarket = (0, market_hooks_1.useAddToMarket)(token.tokenId);
    const { form, fieldHandlers, submit, validationResults } = (0, form_hooks_1.useForm)({
        initialData: helper_1.DEFAULT_FROM,
        validators: (0, helper_1.createValidator)(commonTranslator),
        submit: (form, { isValid }) => __awaiter(void 0, void 0, void 0, function* () {
            if (isValid) {
                const { blockNumber } = yield addToMarket(form.fixedPrice, form.paymentToken);
                onClose(blockNumber);
            }
        }),
    });
    const [approveState, approve] = (0, market_hooks_1.useMarketApprove)(token.tokenId, token.contractAddress);
    return (react_1.default.createElement("div", { className: "c-create-sale-nft-form" },
        react_1.default.createElement("div", { className: "c-create-sale-nft-form__header" }, translator("title")),
        react_1.default.createElement("div", { className: "c-create-sale-nft-form__field" },
            react_1.default.createElement(token_select_1.TokenSelect, { label: translator("paymentTokenLabel"), onChange: fieldHandlers.paymentToken, error: validationResults.results.paymentToken, value: form.paymentToken })),
        react_1.default.createElement("div", { className: "c-create-sale-nft-form__field" },
            react_1.default.createElement(currency_input_1.CurrencyInput, { label: translator("fixedPriceLabel"), placeholder: translator("fixedPricePlaceholder"), currencySymbol: (_a = form.paymentToken) === null || _a === void 0 ? void 0 : _a.symbol, onChange: fieldHandlers.fixedPrice, value: form.fixedPrice, error: validationResults.results.fixedPrice })),
        react_1.default.createElement(default_contract_action_1.DefaultContractAction, { onApprove: approve, actionHandler: submit, actionName: translator("createMarketPositionButton"), approveState: approveState })));
};
exports.CreateSaleNFTForm = CreateSaleNFTForm;
